import _ from 'lodash';
import {createSelector} from 'reselect';

export const navBranch = state => state.nav;

export const routerBranch = state => state.router;

export const modalData = createSelector(
    navBranch,
    nav => nav.openModal
);

export const isModalOpened = createSelector(
    modalData,
  data => modalId => _.get(data, 'id') === modalId
);

export const locationBranch = createSelector(
    routerBranch,
    router => router.location
);

export const currentLocation = createSelector(
    locationBranch,
    location => location.pathname
);



// WEBPACK FOOTER //
// /src/redux/selectors/nav.js